var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "new_releases"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_693_782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_693_782)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "new_releases_2",
    d: "M7.16659 18.75L5.58325 16.0833L2.58325 15.4167L2.87492 12.3333L0.833252 10L2.87492 7.66667L2.58325 4.58333L5.58325 3.91667L7.16659 1.25L9.99992 2.45833L12.8333 1.25L14.4166 3.91667L17.4166 4.58333L17.1249 7.66667L19.1666 10L17.1249 12.3333L17.4166 15.4167L14.4166 16.0833L12.8333 18.75L9.99992 17.5417L7.16659 18.75ZM7.87492 16.625L9.99992 15.7083L12.1666 16.625L13.3333 14.625L15.6249 14.0833L15.4166 11.75L16.9583 10L15.4166 8.20833L15.6249 5.875L13.3333 5.375L12.1249 3.375L9.99992 4.29167L7.83325 3.375L6.66659 5.375L4.37492 5.875L4.58325 8.20833L3.04159 10L4.58325 11.75L4.37492 14.125L6.66659 14.625L7.87492 16.625ZM9.12492 12.9583L13.8333 8.25L12.6666 7.04167L9.12492 10.5833L7.33325 8.83333L6.16659 10L9.12492 12.9583Z",
    fill: "url(#paint0_linear_693_782)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_693_782",
    x1: 9.99992,
    y1: 1.25,
    x2: 9.99992,
    y2: 18.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.197917,
    stopColor: "#009AFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8CA5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.ed935f9220c56b83e039b8103da624ce.svg";
export { ForwardRef as ReactComponent };